"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseOfferMarket__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "offerId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "agreementId",
                type: "uint256",
            },
        ],
        name: "OfferAccepted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "creator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "offerId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "penalty",
                type: "uint256",
            },
        ],
        name: "PurchaseOfferCancelled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "consumer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "offerId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "planTemplateId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "deposit",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "limit",
                type: "uint16",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "minimumAcceptHeight",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "expireDate",
                type: "uint256",
            },
        ],
        name: "PurchaseOfferCreated",
        type: "event",
    },
    {
        inputs: [],
        name: "PER_BILL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PER_MILL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PER_TRILL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "ZERO_ADDRESS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_offerId",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "_mmrRoot",
                type: "bytes32",
            },
        ],
        name: "acceptPurchaseOffer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "acceptedOffer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_offerId",
                type: "uint256",
            },
        ],
        name: "cancelPurchaseOffer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_deploymentId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "_planTemplateId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_deposit",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "_limit",
                type: "uint16",
            },
            {
                internalType: "uint256",
                name: "_minimumAcceptHeight",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_expireDate",
                type: "uint256",
            },
        ],
        name: "createPurchaseOffer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISettings",
                name: "_settings",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_penaltyRate",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_penaltyDestination",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_offerId",
                type: "uint256",
            },
        ],
        name: "isExpired",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "numOffers",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "offerMmrRoot",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "offers",
        outputs: [
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "minimumAcceptHeight",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "planTemplateId",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "expireDate",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "consumer",
                type: "address",
            },
            {
                internalType: "bool",
                name: "active",
                type: "bool",
            },
            {
                internalType: "uint16",
                name: "limit",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "numAcceptedContracts",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "penaltyDestination",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "penaltyRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_penaltyDestination",
                type: "address",
            },
        ],
        name: "setPenaltyDestination",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_penaltyRate",
                type: "uint256",
            },
        ],
        name: "setPenaltyRate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settings",
        outputs: [
            {
                internalType: "contract ISettings",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class PurchaseOfferMarket__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "PurchaseOfferMarket";
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.PurchaseOfferMarket__factory = PurchaseOfferMarket__factory;
PurchaseOfferMarket__factory.bytecode = _bytecode;
PurchaseOfferMarket__factory.abi = _abi;
